import script from "./BikeModules.vue?vue&type=script&setup=true&lang=ts"
export * from "./BikeModules.vue?vue&type=script&setup=true&lang=ts"

import "./BikeModules.vue?vue&type=style&index=0&id=d955bffc&lang=scss"

const __exports__ = script;

export default __exports__